module.exports = __webpack_public_path__ + "static/media/gift-icon-restaurant.575f17e2.svg";